/** Shared ventes list helpers — Historique + Centre Activité (HUB-B.3). */

export function typeBadgeClass(type) {
  if (type === 'retrait') return 'rm-badge rm-badge--danger';
  if (type === 'acompte' || type === 'complement') return 'rm-badge rm-badge--muted';
  return 'rm-badge rm-badge--success';
}

export function historiqueLinkFromFilters(filters) {
  return activiteVentesLinkFromFilters(filters);
}

export function activiteVentesLinkFromFilters(filters) {
  const params = new URLSearchParams({ tab: 'ventes' });
  if (filters?.search) params.set('search', filters.search);
  if (filters?.vendeur) params.set('vendeur', filters.vendeur);
  if (filters?.date_debut) params.set('date_debut', filters.date_debut);
  if (filters?.date_fin) params.set('date_fin', filters.date_fin);
  if (filters?.magasin_id) params.set('magasin_id', filters.magasin_id);
  if (filters?.period) params.set('period', filters.period);
  return `/activite?${params.toString()}`;
}
